// SEO를 위한 헤드 태그를 관리하는 컴포넌트입니다
import React from 'react';
import { Helmet } from 'react-helmet-async';

function SEOHead({ category }) {
  // 기본값 설정
  const defaultTitle = "Baby Flashcards - 유아용 플래시카드 학습앱";
  const defaultDescription = "아이들을 위한 재미있는 플래시카드로 한국어와 영어를 동시에 배워보세요.";
  
  // 카테고리가 있으면 카테고리 정보 사용, 없으면 기본값 사용
  const title = category ? category.title : defaultTitle;
  const description = category ? category.description : defaultDescription;
  const keywords = category ? category.keywords : "유아 플래시카드, 아기 학습, 언어 교육";
  const image = category ? category.image : "/images/default-thumbnail.jpg";

  return (
    <Helmet>
      {/* 페이지 제목 */}
      <title>{title}</title>
      
      {/* 검색엔진용 메타 태그 */}
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* 페이스북, 카카오톡 공유용 태그 */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:type" content="website" />
      
      {/* 트위터 공유용 태그 */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}

export default SEOHead;